import { useSelector } from 'react-redux';
import { selectContainerPackerBySeqId } from '../../../redux/packing';
import { useUserPartyId } from './useUserPartyId';
/**
 * Resolves the packer for a container from the packing store.
 */
export var usePackerForContainer = function (containerId) {
    var containerPackerById = useSelector(selectContainerPackerBySeqId);
    var userPartyId = useUserPartyId();
    var packer = containerId ? containerPackerById === null || containerPackerById === void 0 ? void 0 : containerPackerById[containerId] : undefined;
    return {
        packerName: (packer === null || packer === void 0 ? void 0 : packer.packerName) || (packer === null || packer === void 0 ? void 0 : packer.packerPartyId) || null,
        isMine: !!(packer === null || packer === void 0 ? void 0 : packer.packerPartyId) && packer.packerPartyId === userPartyId
    };
};
